import { Pipe, PipeTransform } from "@angular/core";
import { PPAssignment as Assignment} from "cli-types";

@Pipe({
    name: "assignmentName",
    standalone: false
})
export class AssignmentNamePipe implements PipeTransform {
    transform(assignmentObj: Assignment) {
        // PAS-7135 due to assignable names not being in sync for assignment when modified
        // the title needs to be sourced from the assignable object instead of the actual assignment
        // when available

        let assignmentName = assignmentObj.assignmentName;

        if (assignmentObj.asset) {
            switch (assignmentObj.shortAssignableType) {
                default:
                    assignmentName = assignmentObj.asset.displayName;
                    break;
            }
        }

        return assignmentName;
    }
}
